<template>
  <div
    class="content"
    :style="{height:height+(data.list?data.list.length:0)*17+'px'}"
    :class="{'car-item-radius':showBorderRadius,'car-item-card':boxType == 'card'}"
  >
    <div class="list">
      <div
        class="item flex-center"
        v-for="(item,index) in data.list"
        :id="'item_'+index"
        :key="index"
        :style="divStyle(index)"
        @touchstart="touchstart($event,index)"
        @touchmove="touchmove($event,index)"
        @touchend="touchend($event,index)"
      >
        <div
          class="item-back"
          :style="{width:imgWidth(index),height:'100%',backgroundColor: backgroundColor}"
          @click="navToDetailPage(item,index)"
        >
          <van-image lazy-load v-if="data.type == 'image'" class="item-img" :src="item.src" />
          <div v-if="data.type == 'video'" class="item-img">
            <video
              class="video"
              loop
              :poster="item.cover"
              :src="item.src"
              play-btn-position="center"
              show-mute-btn
              page-gesture
              controls
              muted
              x5-video-player-type="h5-page"
            />
            <div :style="{padding:'10px'}">
              <div class="fs-16">{{item.title}}</div>
              <div
                class="fs-12 d-flex flex-row van-row--justify-space-between van-row--align-center"
              >
                <div>{{item.auth}}</div>
                <div class="text-black-50">{{item.time}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="swiper-dots2 h-100">
      <div
        v-for="(item, index) in data.list"
        :key="index"
        class="block"
        :class="{current:currentIndex == index}"
      />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          type: 'image',
          list: [],
        }
      }
    },
    showBorderRadius: {
      type: Boolean,
      default: true
    },
    boxType: {
      type: String,
      default: 'block'
    },
    backgroundColor: {
      type: String,
      default: 'rgba(255,255,255,1)'
    }
  },
  data () {
    return {
      currentIndex: 0,
      juli: 0,
      moving: false,
      coverTransition: '0s',
      height: 360,
    }
  },
  mounted () {
  },
  methods: {
    navToDetailPage (item, index) {
      let navTo = item.navTo
      if (navTo) {
        if (navTo.indexOf('http') > -1) {
          window.location.href = navTo
        } else {
          this.$router.push(this.$uitl.getPathQuery(navTo))
        }
      }
    },
    //计算div样式
    divStyle (index) {
      let { currentIndex, data, juli, coverTransition, height } = this
      let top = 0
      let zIndex = 0
      if (currentIndex == index) {
        zIndex = data.list.length
        top = zIndex * 17 + juli - 10
      } else {
        if (currentIndex > index) {
          zIndex = data.list.length - (currentIndex - index)
          top = zIndex * 17 - 10
        } else if (currentIndex < index) {
          zIndex = index - currentIndex
          top = zIndex * 17 - 10
        }
      }
      return {
        transition: coverTransition,
        zIndex: zIndex,
        transform: `translateY(${top}px)`,
        opacity: currentIndex == index ? 1 : 0.8,
        height: height + 'px',
      }
    },
    imgWidth (index) {
      let { data } = this
      let zIndex = this.divStyle(index).zIndex
      return 100 - (data.list.length - zIndex) * 8 + '%'
    },
    touchstart (e, index) {
      if (index != this.currentIndex) {
        return
      }
      this.start = e.touches[0].clientY
      this.coverTransition = '0s'
      this.moving = true
    },
    touchmove (e, index) {
      if (index != this.currentIndex) {
        return
      }
      e.preventDefault()
      if (this.moving) {
        let juli = e.touches[0].clientY - this.start
        if (Math.abs(juli) > e.target.height * .95) {
          if (juli > 0) {
            juli = e.target.height * .95
          } else if (juli < 0) {
            juli = -(e.target.height * .95)
          }
        }
        this.juli = juli
      }
    },
    touchend (e, index) {
      if (index != this.currentIndex) {
        return
      }
      let height = e.target.clientHeight || e.target.height
      if (this.juli > height / 3) {
        this.currentIndex -= 1
        if (this.currentIndex < 0) {
          this.currentIndex = this.data.list.length - 1
        }
        this.moving = false
      } else if (this.juli < -height / 3) {
        this.currentIndex += 1
        if (this.currentIndex >= this.data.list.length) {
          this.currentIndex = 0
        }
        this.moving = false
      }
      this.juli = 0
      this.coverTransition = 'all .5s';
    },
  }
}
</script>
<style lang='scss' scoped>
.content {
  overflow: hidden;
  position: relative;
  // background-color: black;
}
.car-item-radius {
  border-radius: 8px;
  overflow: hidden;
}
.car-item-card {
  // padding: 24upx;
  margin: 2px 0;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.2);
  overflow: hidden;
}
.list {
  margin: 0 auto;
  width: 80%;
  position: relative;
}
.item {
  position: absolute;
  width: 100%;
}
.item-back {
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 2px 2px 5px 0 rgba(0, 0, 0, 0.2);
}
.item-img {
  width: 100%;
  height: 100%;
  overflow: hidden;
  transition: all 0.6s;
}
.swiper-dots2 {
  display: flex;
  position: absolute;
  right: calc(10% / 2 - 5px);
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .block {
    width: 7px;
    height: 7px;
    border-radius: 4px;
    background-color: white;
    margin: 3px 0px;
    transition: all 0.5s;
    box-shadow: 2px 2px 5px 0 rgba(0, 0, 0, 0.2);
  }
  .current {
    height: 18px;
    background-color: var(--theme-font-color);
  }
}
.video {
  width: 100%;
  height: 80%;
  background-color: white;
  display: block;
  border-radius: 10px;
}
</style>
